import { arrayOf, shape } from "prop-types";

import __ from "web/Layout/Translations";

import jsonParse from "web/utils/data/parser/string/jsonParse";
import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";
import getProductOrParentImg from "web/utils/page/product/universal/getProductOrParentImg";

import urls from "web/constants/urls";

import ListItem from "./ListItem";
import classes from "./list.scss";

const CustomerCodeListListMobile = ({ items }) =>
  isArrayHasItems(items) ? (
    <ul className={classes.root}>
      {items.map(
        (
          {
            item_id: itemId,
            name,
            order_id: orderId,
            product_id: productId,
            product_expiration_date: expirationDate,
            product_user_used: userUsed,
            product_data: productData,
            product_options: productOptions,
            product_code_status: productStatus,
            order_status_code: orderStatusCode,
            payment_status: paymentStatus,
          },
          index
        ) => {
          const productOptionsParsed = jsonParse(productOptions);
          const productDataParsed = jsonParse(productData);
          const supplierId = productDataParsed.supplier_id;
          const productOptionsAttributes =
            productOptionsParsed?.parent_product_data?.super_attributes;
          const idsAttributeOptions = isArrayHasItems(productOptionsAttributes)
            ? productOptionsAttributes.reduce((result, current) => {
                return current
                  ? [
                      ...result,
                      {
                        attribute: current,
                      },
                    ]
                  : result;
              }, [])
            : [];

          const image = getProductOrParentImg(
            productDataParsed.small_image,
            productOptionsParsed
          );

          const link =
            orderId && productId
              ? urls.customerOrdersOrderProduct
                  .replace(":orderId", orderId)
                  .replace(":productId", productId)
              : null;
          return (
            <li
              data-t1={name}
              className={classes.item}
              // eslint-disable-next-line react/no-array-index-key
              key={`${itemId}${userUsed}${index}`}
            >
              <ListItem
                link={link}
                name={name}
                image={image}
                expirationDate={expirationDate}
                userUsed={userUsed}
                itemId={itemId}
                paymentStatus={paymentStatus}
                options={idsAttributeOptions}
                codeDetails={productOptionsParsed}
                supplierId={supplierId}
                productStatus={productStatus}
                dataT1={`${itemId}_item`}
                producSuperOptions={productDataParsed}
                orderStatusCode={orderStatusCode}
              />
            </li>
          );
        }
      )}
    </ul>
  ) : (
    <div data-t1="code_list_info">{__("Aktualnie nie posiadasz kodów")}</div>
  );

CustomerCodeListListMobile.propTypes = {
  items: arrayOf(shape({})).isRequired,
};

export default CustomerCodeListListMobile;
